import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { CoursePdfsScreenPath } from "./paths.ts";

export function useToCoursePdfs() {
  const navigate = useNavigate();

  const toCoursePdfs = useCallback(() => {
    navigate(CoursePdfsScreenPath);
  }, [navigate]);

  return { toCoursePdfs };
}
